<template>
  <div class="projectReport">
    <div>
      <div class="filterBar">
        <Select1 :style="{margin: 0}" :defaultValue="chartType" @input="$emit('updateMode', $event)" :width="'360px'">
          <option value="createTime">進單數</option>
          <option value="visitDate">預約日單數</option>
          <option value="createTimeReserveNum">預約人數(進單日)</option>
          <option value="visitDateReserveNum">預約人數(預約日)</option>
          <option value="visitDateConsumeP">消費金額(進單日，含快速導購)</option>
          <option value="visitDateConsume">消費金額(預約日，己結帳開立發票) </option>
          <option value="trigger_Num">觸及次數</option>
        </Select1>
        <rangeInput :style="{margin: 0, width: '460px'}" :size="'sm'" :defaultValue="range" @input="$emit('range', $event)"/>
      </div>
      <p v-if="chartType==='trigger_Num'" class="triggerNote">＊觸及次數計算中:同一人在15分鐘內重複進入只會算一次</p>
      <TableVue :rows="report" v-if="report&&report.length>0">
        <template slot="slot_head">
          <th :style="{width: '8em', textAlign:'start'}">{{thead[chartType]}}</th>
          <th v-for="source in yAxis" :key="source">{{source}}</th>
          <th>總計</th>
        </template>
        <tr slot-scope="{item: {_id: date, from, total}, index}">
          <td :style="{textAlign:'start'}">{{date}}</td>
          <td v-for="source in yAxis" :key="`${source}-${index}`">{{from[source]||'-'}}</td>
          <td>{{total}}</td>
        </tr>
        <tr slot="foot" class="foot" :style="{borderTop:'1px solid '}">
          <td v-if="chartType==='trigger_Num'">總計(點擊次數)</td>
          <td v-else>總計</td>
          <td v-for="source in yAxis" :key="`${source}-total`">{{total[source]||'-'}}</td>
          <td>{{count}}</td>
        </tr>
      </TableVue>
    </div>
    <div>
      <template v-if="series.length>0">
        <ChartVue :series="series" :xAxis="xAxis" :yAxis="yAxisName[chartType]" :title="title[chartType]" :colors="colors"/>
      </template>
    </div>
  </div>
</template>

<script>
import rangeInput from '../../../components/input/dateRange.vue'
import TableVue from '../../../components/tables/t2.vue'
import ChartVue from './Chart.vue'
export default {
  name: 'report',
  components: { TableVue, ChartVue, rangeInput },
  props: ['report', 'project', 'total', 'count', 'series', 'xAxis', 'yAxis', 'chartType', 'range'],
  data () {
    return {
      colors: ['#01cadc', '#48c3fc', '#65a6fa', '#7e80e7', '#9b58cc', '#bb109d', '#d0005e', '#de5046', '#f7914f', '#ffbbbc'],
      thead: {
        createTime: '進單日期',
        visitDate: '預約日期',
        createTimeReserveNum: '進單日期',
        visitDateReserveNum: '預約日期',
        visitDateConsume: '預約日期',
        visitDateConsumeP: '進單日期',
        trigger_Num: '觸及次數'
      },
      yAxisName: {
        createTime: '進單數(筆)',
        visitDate: '預約日單數(筆)',
        createTimeReserveNum: '預約人數',
        visitDateReserveNum: '預約人數',
        visitDateConsume: '消費金額(元)',
        visitDateConsumeP: '消費金額(元)',
        trigger_Num: '觸及次數(次)'
      },
      title: {
        createTime: '進單數統計',
        visitDate: '日預約單數統計',
        createTimeReserveNum: '預約人數統計(進單日)',
        visitDateReserveNum: '預約人數統計(預約日)',
        visitDateConsume: '消費金額統計(預約日)',
        visitDateConsumeP: '消費金額統計(進單日)',
        trigger_Num: '觸及次數'
      }
    }
  },
  watch: {
  },
  computed: {
    sources () {
      return Array.from(new Set([].concat(...this.report.map(e => Object.keys(e.from)))))
    }
  }
}
</script>

<style lang="scss" scoped>
.filterBar {
  height: 40px;
  margin-bottom: 30px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 20px;
}
.projectReport {
  display: grid;
  grid-template-columns: 1fr 900px;
  &>div{
    padding: 40px 20px;
    max-height: calc(100vh - 90px);
    min-height: calc(100vh - 90px);
    overflow-y: auto;
  }
}
.triggerNote {
  font-size: 13px;
  color: #888;
  letter-spacing: .1em;
  margin-bottom: 10px;
  text-align: end;
}
.foot {
  td {
    font-weight: 700;
    height: 60px;
  }
}
</style>
